const en = {
	// Common UI
	'Evet': 'Yes',
	'Hayır': 'No',
	'Kapat': 'Close',
	'Tamam': 'OK',
	'Vazgeç': 'Cancel',
	'Geri': 'Back',
	'Kaydet': 'Save',
	'Sil': 'Delete',
	'Daha Fazla': 'More',
	'Tümünü Gör': 'See All',
	'Bugün': 'Today',
	'Yarın': 'Tomorrow',
	'Hatalı Tarih': 'Invalid Date',

	// Payment / NFC
	'Bankaya yönlendiriliyorsunuz...': 'Redirecting to your bank...',
	'Ödeme sayfası yüklenirken bir hata oluştu, lütfen tekrar deneyin.': 'An error occurred while loading the payment page, please try again.',
	'Ödeme Al': 'Take Payment',
	'Ödeme Başarılı': 'Payment Successful',
	'Kapat ve Sipariş Ekranını Sıfırla': 'Close and Reset Order Screen',
	'Ödeme Cihazını Telefonunuza Yaklaştırın': 'Bring the Payment Device Close to Your Phone',

	// Footer
	'Bizi Takip Et, Gecenin Enerjisine Ortak Ol!': 'Follow Us, Be Part of the Night\'s Energy!',
	'Bizi sosyal medyada takip ederek': 'Follow us on social media',
	'gecenin nabzını tut!': 'and feel the pulse of the night!',
	'Bilet Destek': 'Ticket Support',
	'Biletler hakkında tüm soru ve görüşlerinizi': 'For all your questions and feedback about tickets,',
	'whatsapp üzerinden bize yazabilirsiniz!': 'you can reach us via WhatsApp!',
	'Hakkımızda': 'About Us',
	'Sıkça Sorulan Sorular': 'Frequently Asked Questions',
	'İletişim': 'Contact',
	'Tüm Hakları Saklıdır': 'All Rights Reserved',

	// Header
	'Bildirimler': 'Notifications',
	'Ana Menü': 'Main Menu',

	// Header Checkout
	'Bilet Seçimi': 'Ticket Selection',
	'Ödeme': 'Payment',
	'Hesap Özeti': 'Account Summary',
	'Ana Sayfaya Geri Dön': 'Back to Home Page',

	// Event Calendar & Programme
	'BİLET AL': 'BUY TICKET',
	'Detayları Gör': 'View Details',

	// Home Navigation
	'Etkinlik Hakkında': 'About the Event',
	'Bilmeniz Gerekenler': 'Things to Know',
	'Alan Haritası': 'Site Map',

	// Mobile Nav
	'Ana Sayfa': 'Home',
	'Cüzdan': 'Wallet',
	'Cüzdan Hareketleri': 'Wallet Transactions',
	'Cüzdan Bakiyesi Yükle': 'Load Wallet Balance',
	'Ödeme Yap': 'Make Payment',
	'Etkinlik Hk.': 'About Event',
	'S.S.S.': 'FAQ',
	'Hesabım': 'My Account',

	// Wallet Info Modal
	'Cüzdan Bilgisi': 'Wallet Information',
	'Kullanıcı Bakiyesi:': 'User Balance:',
	'Cüzdan hareketleri getiriliyor...': 'Loading wallet transactions...',
	'Sipariş Detayı': 'Order Details',
	'İşlem geçmişi boş.': 'Transaction history is empty.',

	// Pages
	'Ad': 'First Name',
	'Adım 1': 'Step 1',
	'Adım 2': 'Step 2',
	'Adım 3': 'Step 3',
	'Adım 4': 'Step 4',
	'Adınızı girmelisiniz.': 'You must enter your first name.',
	'Aktif': 'Active',
	'Aktif Biletler': 'Active Tickets',
	'Akış': 'Flow',

	// User Actions
	'Kullanıcı İşlemleri': 'User Actions',
	'NFC Eşleştir': 'Pair NFC',
	'QR Eşleştir': 'Pair QR',
	'Telefon numarası ile ara': 'Search by phone number',
	'QR kodu ile ara': 'Search by QR code',
	'Misafir Kullanıcı Oluştur': 'Create Guest User',
	'Misafir kullanıcı oluşturmak istediğinizden emin misiniz?': 'Are you sure you want to create a guest user?',
	'Kullanıcı QR\'ı Arama': 'Search User QR',
	'Cüzdan bilgisi getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading wallet information, please try again.',
	'Akşam serinleyebileceğini unutmadan gelmeni tavsiye ederiz.': 'We recommend that you come prepared for it to get cooler in the evening.',
	'Alana gelmek için en iyi opsiyon YandexGo kullanmak.': 'The best option for getting to the venue is to use YandexGo.',
	'Alanda Vestiyer & Emanet Eşya noktası olacağı için yanında getirdiğin her şeyi buraya bırakıp daha sonra tekrar teslim alabilirsin.': 'There will be a cloakroom and belongings drop-off point at the venue, so you can leave anything you bring there and collect it again later.',
	'Alanda otopark son derece sınırlıdır. Etkinlik alanından maksimum derecede faydalanmak için alana araçla gelmeni tavsiye etmeyiz.': 'Parking at the venue is extremely limited. To make the most of the event area, we do not recommend coming by car.',
	'Alan’da oluşabilecek sağlık sorunlarına karşılık sağlık ekibimiz yerini alacaktır.': 'Our medical team will be on site for any health issues that may arise at the venue.',
	'Alttaki barda “Hesabım” Butonu altında “Cüzdanım” Sekmesine tıkla.': 'Tap the “My Wallet” tab under the “My Account” button in the bottom bar.',
	'Ana ekrana dön': 'Return to the home screen',
	'Anasayfaya dön': 'Return to the homepage',
	'Aradığınız etkinlik bulunamadı.': 'The event you are looking for could not be found.',
	'Aradığınız içeriği bulamadık.': 'We could not find the content you are looking for.',
	'Aradığınız {{eventTitle}} etkinliği bulunamadı.': 'The event {{eventTitle}} you are looking for could not be found.',
	'Arama Sonuçları: "{{searchText}}"': 'Search Results: "{{searchText}}"',
	'"{{searchText}}" kelimesine dair etkinlik sonuçları.': 'Event results for "{{searchText}}".',
	'Artık eğlencenin tadını çıkarmaya hazırsın! Alt menüde bulunan cüzdan butonu ile çıkan QR Kodu kasalarda okutarak harcama yapabilirsin.': 'You are now ready to enjoy the fun! You can make purchases by scanning the QR code that appears from the wallet button in the bottom menu at the cashier points.',
	'Artık eğlencenin tadını çıkarmaya hazırsın! Kasa noktalarında bilekliğini okutarak harcama yapabilirsin.': 'You are now ready to enjoy the fun! You can make purchases by tapping your wristband at the cashier points.',
	'Bakiye Yükle': 'Load Balance',
	'Bakiye Yükleme': 'Load Balance',
	'Bakiyemi kullanmak istiyorum.': 'I want to use my balance.',
	'Beklenmedik bir hata oluştu.': 'An unexpected error occurred.',
	'Toplam yükleme tutarı 0\'dan fazla olmalıdır.': 'Total loading amount must be more than 0.',
	'Nakit Ödeme Miktarı': 'Cash Payment Amount',
	'Nakit ödeme miktarını belirtmelisiniz.': 'You must specify the cash payment amount.',
	'Kartla Ödeme Miktarı': 'Card Payment Amount',
	'Kartla ödeme miktarını belirtmelisiniz.': 'You must specify the card payment amount.',
	'{{name}} {{surname}} isimli kullanıcının cüzdanına toplam <strong>{{amount}}</strong> yüklenecek. Onaylıyor musunuz?': '{{amount}} will be loaded to the wallet of the user named {{name}} {{surname}}. Do you confirm?',
	'Kullanıcılar getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading users, please try again.',
	'Kullanıcı başarıyla oluşturuldu.': 'User created successfully.',
	'Kullanıcı oluşturulurken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while creating the user, please try again.',
	'Misafir kullanıcı başarıyla oluşturuldu.': 'Guest user created successfully.',
	'Misafir kullanıcı oluşturulurken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while creating the guest user, please try again.',
	'Biletler getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading tickets, please try again.',
	'Bilet okunurken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while reading the ticket, please try again.',
	'Satıcılar getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading merchants, please try again.',
	'Sipariş oluşturulurken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while creating the order, please try again.',
	'Ödeme alınırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while processing payment, please try again.',
	'Raporlar getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading reports, please try again.',
	'Bakiye yükleme başarılı.': 'Balance loaded successfully.',
	'Bakiye yüklenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading balance, please try again.',
	'Kart eşleştirme başarılı.': 'Card pairing successful.',
	'Kart eşleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while pairing the card, please try again.',
	'Kart ekleme başarılı.': 'Card added successfully.',
	'Kart eklenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while adding the card, please try again.',
	'Cüzdan hareketleri getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading wallet transactions, please try again.',
	'Bilet Ekle': 'Add Ticket',
	'Bilet Fiyatı': 'Ticket Price',
	'Bilet Kategorileri': 'Ticket Categories',
	'Bilet Seçin': 'Choose Ticket',
	'Bilet Seçin - {{eventTitle}} / {{eventDate}} {{eventLocation}}': 'Choose Ticket - {{eventTitle}} / {{eventDate}} {{eventLocation}}',
	'Bilet bilgileriniz getiriliyor...': 'Your ticket information is being loaded...',
	'Bilet bulunamadı': 'Ticket not found',
	'Bilet satın almak için üye girişi yapmalısınız.': 'You must sign in to buy a ticket.',
	'Bilet Kontrol': 'Ticket Control',
	'Bilet Özeti': 'Ticket Summary',
	'Bilet Özeti - {{eventTitle}} / {{eventDate}} {{eventLocation}}': 'Ticket Summary - {{eventTitle}} / {{eventDate}} {{eventLocation}}',
	'Biletlerim': 'My Tickets',
	'Biletleriniz:': 'Your Tickets:',
	'Bildirimlerim': 'My Notifications',
	'Bilgilerim': 'My Information',
	'Bir konu başlığı seçin.': 'Select a topic.',
	'Bir konu seçmelisiniz.': 'You must select a subject.',
	'Bir satıcı seçmelisiniz.': 'You must select a merchant.',
	'Bir sayfa seçin.': 'Select a page.',
	'Blok': 'Block',
	'Blok seçmelisiniz.': 'You must select a block.',
	'Bu Bileti İptal Et': 'Cancel This Ticket',
	'Bu formu görmek için üye girişi yapmanız gerekiyor.': 'You need to sign in to view this form.',
	'Bunu alternatif olarak M4 Metro hattında Adliye durağında inerek de gelebilirsin.': 'Alternatively, you can also come by taking the M4 Metro line and getting off at Adliye station.',
	'CVC': 'CVC',
	'CVV girmelisiniz.': 'You must enter the CVV.',
	'Cüzdan Bakiyeniz:': 'Your Wallet Balance:',
	'Cüzdanım': 'My Wallet',
	'Cüzdan kullanım koşullarını': 'the wallet terms of use',
	'Cüzdan kullanım koşullarını onaylamalısınız.': 'You must accept the wallet terms of use.',
	'Cüzdanındaki “Bakiye yükle” Butonuna basarak kredi kartın ile sayfadaki belirlenmiş miktarda veya istediğin miktarda yükleme yap. Eğer kredi kartın yoksa alandaki yükleme noktalarından nakit yükleme yapabilirsin.': 'Tap the “Load Balance” button in your wallet and load either the preset amount shown on the page or any amount you want with your credit card. If you do not have a credit card, you can load cash at the top-up points in the venue.',
	'Cüzdanınızdaki bakiyeniz ile bilet satın alabilir veya mevcut bakiyenizi bilet ücretinden düşerek kalan tutarı kartınız ile ödeyebilirsiniz.': 'You can buy tickets with your wallet balance, or use your current balance toward the ticket price and pay the remaining amount with your card.',
	'Daha önceki seçimimi iptal etmek istiyorum.': 'I want to cancel my previous selection.',
	'Devam etmek için eşleştirme yapmak istediğiniz kullanıcının telefon numarası giriniz.': 'To continue, please enter the phone number of the user you want to pair with.',
	'Devam etmek için mesafeli satış sözleşmesini kabul etmelisiniz.': 'You must accept the distance sales agreement to continue.',
	'Diğer Performanslar': 'Other Performances',
	'E-Posta': 'Email',
	'E-Posta adresinizi girmelisiniz.': 'You must enter your email address.',
	'E-posta adresinizi girmelisiniz.': 'You must enter your email address.',
	'E-posta ile bilgilendirilmeyi kabul ediyorum.': 'I agree to receive updates by email.',
	'Etkinlik': 'Event',
	'Etkinlik - {{time}}': 'Event - {{time}}',
	'Etkinlik Bulunamadı': 'Event Not Found',
	'Etkinlik Bulunamadı.': 'Event Not Found.',
	'Etkinlik Kuralları': 'Event Rules',
	'Etkinlik alanına giriş yapan seyircilerin alandan çıkış yapmaları halinde tekrar alana girebilmeleri için yeni bilet satın almaları gerekmektedir.': 'Audience members who leave the event area after entering must purchase a new ticket to re-enter.',
	'Etkinlik alanına portatif kamp sandalyesi, mat gibi eşyalar alınmayacaktır.': 'Portable camping chairs, mats, and similar items will not be allowed into the event area.',
	'Etkinlik girişinde kimlik kontrolü yapılacaktır.': 'ID checks will be carried out at the event entrance.',
	'Etkinlik günü görevlilierimize kayıtlı telefon numaranızı söyleyerek veya oluşturacağınız QR Kodunu göstererek etkinliğe giriş yapabilirsiniz.': 'On the day of the event, you can enter by telling our staff your registered phone number or by showing the QR code you will create.',
	'Etkinlik mekanına kamera, fotoğraf makinası, ses cihazı vb. alınmayacaktır.': 'Cameras, photo cameras, audio devices, etc. will not be allowed into the event venue.',
	'Etkinlik sesli ve görsel çekimi yapılarak kayıt altına alınmakta olup {{brandName}} Organizasyonu bu görüntü ve sesleri her tür yayın mecrasında yayınlama hakkı bulunmaktadır.': 'The event is being recorded with audio and video, and {{brandName}} Organization has the right to publish these images and sounds on all types of media channels.',
	'Etkinlikler': 'Events',
	'Etkinlikler - {{locationTitle}}': 'Events - {{locationTitle}}',
	'Etkinlikte 18 yaş sınırı vardır.': 'The event has an age limit of 18.',
	'Etkinlikte oturma düzeni yoktur. Tüm kategoriler ayaktadır.': 'There is no seating arrangement at the event. All categories are standing.',
	'Etkinlik sonunda uygulamada bakiye kalması durumunda ne olacak?': 'What happens if there is remaining balance in the app at the end of the event?',
	'Workshop bilgisi bulunamadı.': 'Workshop information not found.',
	'En Eski': 'Oldest First',
	'En Yeni': 'Newest First',
	'Etkinliğe Gelirken Bilmeniz Gereken Her Şey! 👉🏻': 'Everything You Need to Know Before Coming to the Event! 👉🏻',
	'Filtre': 'Filter',
	'Fiyat güncellenme tarihi': 'Price last updated',
	'Festival Programı': 'Festival Programme',
	'Festivalde bütün ödemelerini {{brandName}} uygulaması üzerinden yapabilirsin.': 'You can make all your payments at the festival through the {{brandName}} app.',
	'Geçerli bir tarih girmelisiniz.': 'You must enter a valid date.',
	'Form Getiriliyor...': 'Form Loading...',
	'Form bilgisi getiriliyor...': 'Form information is being loaded...',
	'Formu doldurarak bize ulaş, en kısa zamanda sana geri dönelim ;)': 'Reach us by filling out the form, and we will get back to you as soon as possible ;)',
	'Geri Git': 'Go Back',
	'Geçerli bir isim girmelisiniz.': 'You must enter a valid name.',
	'Geçerli bir telefon numarası girmelisiniz.': 'You must enter a valid phone number.',
	'Geçmiş': 'Past',
	'Geçmiş Biletler': 'Past Tickets',
	'Giriş Yap': 'Sign In',
	'Hoşgeldin': 'Welcome',
	'Telefonuna gelecek SMS şifresi ile giriş yapabilirsin. Lütfen önce telefon numaranı gir.': 'You can sign in with the SMS code sent to your phone. Please enter your phone number first.',
	'Geri Dön': 'Go Back',
	'Girişte yaşanacak yoğunluktan etkilenmemek için erken gelmeni tavsiye ederiz.': 'We recommend arriving early so you are not affected by the crowd at the entrance.',
	'Grup Seçimi': 'Group Selection',
	'Grup seçmelisiniz.': 'You must select a group.',
	'Gönder': 'Submit',
	'Gösteriyi izleyen her seyirci, gösterinin kayıt altına alınmasına ve kaydın her türlü kullanımına herhangi bir bedel talep etmeksizin gayri kabili rücu olarak muvafakat etmiştir.': 'Every audience member watching the show irrevocably consents to the recording of the show and to any use of that recording without claiming any fee.',
	'Güvenli Ödeme Adımına Geç': 'Proceed to Secure Payment',
	'iyzico ile Güvenli Ödeme': 'Secure Payment with iyzico',
	'Kartımı daha sonra kullanmak üzere kaydetmek istiyorum.': 'I want to save my card for later use.',
	'iyzico kart saklama, ödeme kartlarını saklayarak, daha sonraki işlemlerinizde kart bilgilerinizi tekrar vermeden kolay ve hızlı ödeme yapabilmenizi sağlayan güvenli bir servistir.': 'iyzico card saving is a secure service that allows you to save payment cards and make easy and fast payments in your future transactions without having to enter your card information again.',
	'Harcamalarınız uygulama üzerinden gerçekleşecektir. İçeride nakit veya kredi kartı ödemesi almamaktayız.': 'Your spending will be made through the app. We do not accept cash or credit card payments inside.',
	'Haritada Gör': 'View on Map',
	'Henüz bir bildiriminiz bulunmuyor.': 'You have no notifications yet.',
	'Haritayı Gizle': 'Hide Map',
	'Hava Durumu & Giyinme & Vestiyer': 'Weather & Clothing & Cloakroom',
	'Hesabım ile ilgili bir sorun oluştu ne yapmalıyım?': 'What should I do if I have a problem with my account?',
	'Hesabınızda bir sorunla karşılaştığınızda, "Çözüm Masası" noktamıza gidip destek alabilirsiniz. Ekibimiz en kısa sürede sorununuzu çözmek için çalışacaktır.': 'If you encounter a problem with your account, you can go to our "Solution Desk" point and get support. Our team will work to resolve your issue as soon as possible.',
	'Hesabımı Sonlandır': 'Close My Account',
	'Hesabınızı iptal etmek istediğinizden emin misiniz?': 'Are you sure you want to cancel your account?',
	'Hesap silme talebinizi <strong>{{date}}</strong> tarihi itibariyle aldık. Bu tarihten itibaren en geç 15 gün içinde hesap bilgileriniz tamamen silinecek.': 'We received your account deletion request as of <strong>{{date}}</strong>. Your account information will be completely deleted within 15 days from this date at the latest.',
	'Kalan tutarın çekilmesi için kart bilgilerinizi aşağıdaki alana giriniz': 'Enter your card details below to charge the remaining amount',
	'Kapı Açılış': 'Doors Open',
	'Kapı Açılış 17:00': 'Doors Open 17:00',
	'Kapı Açılışı': 'Doors Open',
	'Kapı açılış saati 17:00’dir.': 'Doors open at 17:00.',
	'Kart Numarası': 'Card Number',
	'Kampanyalar': 'Promotions',
	'Kart bilgilerinizi aşağıdaki alana giriniz': 'Enter your card details in the field below',
	'Kart Bilgilerinizi Giriniz': 'Enter Your Card Details',
	'Kart numaranızı girmelisiniz.': 'You must enter your card number.',
	'Kart üzerindeki isim alanını girmelisiniz.': 'You must enter the name on the card.',
	'Karttan Çekilecek Tutar': 'Amount to Be Charged to Card',
	'Kartın Üzerindeki İsim': 'Name on Card',
	'Kartınız başarıyla silindi.': 'Your card was deleted successfully.',
	'Kartınız silinirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while deleting your card, please try again.',
	'Konser alanına dışarıdan yiyecek ve içecek alınmayacaktır.': 'No food or drinks from outside will be allowed into the concert area.',
	'Konu': 'Subject',
	'Kayıtlı Kart': 'Saved Card',
	'Kamera İzni İste': 'Request Camera Permission',
	'Kullanıcı Telefon Numarası': 'User Phone Number',
	'Kullanıcı bilgileriniz getirirken bir hata ile karşılaşıldı. Lütfen sayfayı yenileyerek tekrar deneyin.': 'An error occurred while fetching your user information. Please refresh the page and try again.',
	'Kullanıcı bilgileri getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading user information.',
	'Kullanıcı bilgisi getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading user information.',
	'Kullanıcı bulunamadı': 'User not found',
	'Menü': 'Menu',
	'Menü getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading the menu.',
	'Menüye Git': 'Go to Menu',
	'Menüyü Gör': 'View Menu',
	'Mobil uygulamamızı indirerek hızlı ve sıra beklemeden sipariş verebilir, masaya getir özelliği ile yerinizden kalkmadan siparişinize ulaşabilirsiniz.': 'Download our mobile app to order quickly without waiting in line, and have your order delivered to your table without leaving your seat.',
	'Şikayet ve Öneri': 'Feedback & Suggestions',
	'Mesafeli satış sözleşmesi': 'the Distance Sales Agreement',
	'Misafir': 'Guest',
	'Mesajınız en az {length} karakter içermelidir.': 'Your message must contain at least {length} characters.',
	'Mesajınızı girmelisiniz.': 'You must enter your message.',
	'Mevsim normallerinde bir hava durumu bizi bekliyor! Meteoroloji’den aldığımız bilgilere göre hissedilen sıcaklık 17 Derece civarlarında seyredecek.': 'Seasonal weather conditions are expected! According to the information we received from the meteorology service, the perceived temperature will be around 17 degrees.',
	'Neler oluyor?': 'What is going on?',
	'Organizasyon firması, diğer misafirleri rahatsız eden/edecek nitelikte, uygun görmediği kişileri etkinlik için bilet bedelini iade etmek koşuluyla, etkinlik mekanına kişiyi almama hakkına sahiptir.': 'The organizing company reserves the right to deny entry to any person it deems inappropriate or likely to disturb other guests, provided that the ticket fee for the event is refunded.',
	'Organizasyon şirketinin programda ve bilet fiyatlarında değişiklik yapma hakkı saklıdır.': 'The organization company reserves the right to make changes to the program and ticket prices.',
	'Organizatör etkinlik için uygun görmediği kişileri, bilet ücretini iade ederek etkinlik mekanına almama hakkına sahiptir.': 'The organizer reserves the right to deny entry to the event venue to anyone deemed unsuitable for the event by refunding the ticket fee.',
	'Otopark': 'Parking',
	'QR Kodu Göster': 'Show QR Code',
	'QR Kodu Okutun': 'Scan the QR Code',
	'Yenile': 'Refresh',
	'Cüzdanıma Git': 'Go to My Wallet',
	'Kamera hazırlanıyor...': 'Preparing the camera...',
	'QR okuyucu başlatılamadı, lütfen tekrar deneyin.': 'The QR reader could not be started, please try again.',
	'SKT': 'Expiry Date',
	'SKT seçmelisiniz.': 'You must select the expiry date.',
	'Satıcı': 'Merchant',
	'Satış Adedi': 'Sales Quantity',
	'{{count}} Ad.': '{{count}} pcs.',
	'Sayfa bulunamadı.': 'Page not found.',
	'Sıra': 'Row',
	'SMS ile bilgilendirilmeyi kabul ediyorum.': 'I agree to receive updates via SMS.',
	'SMS kodunu girin.': 'Enter the SMS code.',
	'6 Haneli SMS kodunu girin.': 'Enter the 6-digit SMS code.',
	'Tekrar SMS Gönder': 'Resend SMS',
	'SMS gönderilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while sending the SMS, please try again.',
	'SMS onaylanırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while verifying the SMS, please try again.',
	'{{phone}} numaralı telefonunuza gelen SMS kodunu aşağıdaki alana giriniz.': 'Please enter the SMS code sent to <0>{{phone}}</0> below.',
	'{{phone}} numaralı telefonunuza ve kayıtlı e-posta adresinize gönderilen kodu aşağıdaki alana giriniz.': 'Please enter the code sent to <0>{{phone}}</0> and your registered email address below.',
	'Kayıtlı e-posta adresinize gönderilen kodu aşağıdaki alana giriniz.': 'Please enter the code sent to your registered email address below.',
	'{{phone}} numaralı telefonunuza gönderilen şifreyi giriniz.': 'Please enter the password sent to <0>{{phone}}</0>.',
	'{{phone}} numaralı telefonunuza ve kayıtlı e-posta adresinize gönderilen şifreyi giriniz.': 'Please enter the password sent to <0>{{phone}}</0> and your registered email address.',
	'Kayıtlı e-posta adresinize gönderilen şifreyi giriniz.': 'Please enter the password sent to your registered email address.',
	'Sanatçı Detayı': 'Artist Details',
	'Satın alınan biletlerde iptal, iade ve değişiklik yapılmamaktadır.': 'Purchased tickets cannot be cancelled, refunded, or changed.',
	'Sayfalar': 'Pages',
	'Sağlık': 'Health',
	'Seçimimi iptal etmek istiyorum.': 'I want to cancel my selection.',
	'Ne yemek istersin?': 'What would you like to eat?',
	'Temizle': 'Clear',
	'Sipariş bulunamadı.': 'Order not found.',
	'Sipariş Ver': 'Place Order',
	'Sepetim': 'My Basket',
	'Sepetiniz getiriliyor...': 'Loading your basket...',
	'Sepetinizde ürün bulunmuyor.': 'Your basket is empty.',
	'Çıkar': 'Remove',
	'Adet': 'pcs',
	'Ekle': 'Add',
	'Toplam:': 'Total:',
	'Sepete Ekle': 'Add to Basket',
	'Bu ürünü şu an sepetinize ekleyemezsiniz.': 'You cannot add this item to your basket at the moment.',
	'Sepete Git': 'Go to Basket',
	'Devam Et': 'Continue',
	'<strong>{{branch}}</strong> mağazamızda ne yazık ki uygulama üzerinden sipariş alamıyoruz.': 'Unfortunately, we cannot accept orders through the app at our <strong>{{branch}}</strong> store.',
	'Mağazamızdaki kiosk ve kasalardan sipariş verebilirsiniz.': 'You can place orders at our in-store kiosks and cashiers.',
	'Ürün bulunamadı.': 'No products found.',
	'Ürün Detayı': 'Product Details',
	'Şube Getiriliyor...': 'Loading branch...',
	'Yükleniyor': 'Loading',
	'Masa {{number}}': 'Table {{number}}',
	'/ad': '/unit',
	'Ürün için sipariş notlarınız.': 'Order notes for this product.',
	'Hatalı bir QR okuttunuz.': 'You scanned an invalid QR code.',
	'Bu ürün <strong>{{hours}}</strong> saatleri arasında satılmaktadır.': 'This product is available between <strong>{{hours}}</strong>.',
	'Alerjenler': 'Allergens',
	'Besin Değerleri': 'Nutrition Values',
	'Soyad': 'Surname',
	'Soyadınızı girmelisiniz.': 'You must enter your surname.',
	'Soyisim': 'Surname',
	'Sıkça sorulan sorular': 'Frequently asked questions',
	'Tebrikler': 'Congratulations',
	'Telefon': 'Phone',
	'Telefonumun şarjı bittiğinde, uygulamayı kullanmaya devam etmek için ne yapabilirim?': 'What can I do to continue using the app when my phone runs out of battery?',
	'Telefonunuzun şarjı bittiyse, kasa noktalarına gidip QR kart almalısınız. Bu kart sayesinde uygulamayı kullanmaya devam edebilirsiniz, bu nedenle en yakın ödeme noktasına gitmeyi unutmayın. QR kartınızı güvende tutun ve başkalarıyla paylaşmamaya özen gösterin.': 'If your phone battery runs out, you should go to the cashier points and get a QR card. Thanks to this card, you can continue using the app, so do not forget to go to the nearest payment point. Keep your QR card safe and be careful not to share it with others.',
	'Telefon numaranızı girmelisiniz.': 'You must enter your phone number.',
	'Toplam Ciro': 'Total Revenue',
	'Toplam Satış Adedi': 'Total Sales Quantity',
	'Tutar Girin': 'Enter Amount',
	'Tutarı değiştir': 'Change amount',
	'Telefonunu şarj etmeyi unutma çünkü alanda kredi kartı - nakit geçerli değil. Uygulamayı indirmek için BIO’daki linki takip et.': 'Do not forget to charge your phone because credit cards and cash are not valid in the venue. Follow the link in the BIO to download the app.',
	'Toplam': 'Total',
	'Toplam Bakiye': 'Total Balance',
	'Tüm Etkinlikler': 'All Events',
	'Tüm Konumlar': 'All Locations',
	'Tüm etkinlikler': 'All events',
	'Tümü': 'All',
	'Ulaşım': 'Transportation',
	'Uygulamada QR kodu oluşturmak için ne yapmalıyım?': 'What should I do to generate a QR code in the app?',
	'Uygulama anasayfasının altında bulunan cüzdan butonuna basmanız yeterli olacaktır. Açılan QR kodu sadece 30 saniye geçerlidir. 30 saniye geçtikten sonra "Yenile" butonunu kullanarak QR kodunuzu yenileyebilirsiniz.': 'It is enough to press the wallet button located at the bottom of the app home page. The QR code that opens is only valid for 30 seconds. After 30 seconds, you can renew your QR code by using the "Refresh" button.',
	'Uygulamadaki alışveriş sistemi nasıl çalışmaktadır?': 'How does the shopping system in the app work?',
	'Uygulamadaki alışveriş sistemi, hesabınıza online kredi kartı ile veya alanda bulunan ödeme noktalarından para yükleyerek çalışır. Yüklediğiniz para, hesabınıza online bakiye olarak aktarılır. Sonrasında istediğiniz ürün veya hizmet için ödeme yapmak için kasa noktalarına gidebilir. Bu noktalarda, uygulamada bulunan size özel ve her alışverişte yenilenen QR kodunu kullanarak alışveriş yapabilirsiniz. QR kodu, ödeme işlemini güvenli ve hızlı bir şekilde tamamlamanızı sağlar. Bu yöntem sayesinde, alışverişlerinizi kolaylıkla gerçekleştirebilir ve uygulamadaki bakiyenizi harcayabilirsiniz.': 'The shopping system in the app works by loading money into your account online with a credit card or from the payment points located in the venue. The money you load is transferred to your account as online balance. Afterwards, you can go to the cashier points to pay for any product or service you want. At these points, you can shop by using the QR code in the app that is unique to you and refreshed with every purchase. The QR code allows you to complete the payment process securely and quickly. With this method, you can easily complete your purchases and spend your balance in the app.',
	'Uygulamadaki hesabıma bakiye yüklemek için hangi adımları izlemeliyim?': 'Which steps should I follow to load balance into my account in the app?',
	'1-Uygulamaya giriş yapın veya uygulamada hesabınıza oturum açın. <br />2-Hesabım bölümü kısmında cüzdanım sekmesine tıklayın. <br />3- Bakiye yükle butonundan bakiye yüklemek istediğiniz tutarı girin. <br />4-Ödeme yapmak istediğiniz kart bilgileri girin ve yükleme yap butonuna basınız. Dilerseniz diğer ödemelerde kart bilgilerini kaydederek ödeme yapabilirsiniz. <br />': '1-Sign in to the app or log in to your account in the app. <br />2-Click the my wallet tab under the My Account section. <br />3-Enter the amount you want to load using the load balance button. <br />4-Enter the card details you want to use for payment and press the load button. If you wish, you can save your card details and use them for future payments. <br />',
	'Uygulamayı nasıl kullanırım?': 'How do I use the app?',
	'Yaklaşan Performanslar': 'Upcoming Performances',
	'Yardım': 'Help',
	'Yeni Kullanıcı Oluştur': 'Create New User',
	'Yeniden Gönder': 'Send Again',
	'numaralı işleminiz başarıyla tamamlanmıştır.': 'transaction has been completed successfully.',
	'sayfamızı ziyaret edebilirsiniz.': 'you can visit our page.',
	'{{bookingType}} biletiniz bulunmuyor.': 'You have no {{bookingType}} tickets.',
	'{{branchTitle}} Etkinlikleri': '{{branchTitle}} Events',
	'{{branchTitle}} İletişim Bilgileri': '{{branchTitle}} Contact Information',
	'{{brandName}} Cüzdanım': '{{brandName}} My Wallet',
	'{{brandName}} iletişim bilgileri.': '{{brandName}} contact information.',
	'{{brandName}} içerik sayfaları': '{{brandName}} content pages',
	'{{brandName}} uygulamasını harcamalarınızda kullanabilmek Için öncelikle üye olmalısın. Zaten üye isen giriş yap.': 'To use the {{brandName}} app for your spending, you first need to sign up. If you are already a member, sign in.',
	'{{eventDate}} tarihli {{eventLocation}} {{eventTitle}} biletleriniz.': 'Your tickets for {{eventTitle}} at {{eventLocation}} on {{eventDate}}.',
	'{{eventDate}} tarihli {{eventLocation}} {{eventTitle}} etkinliği - {{brandName}}': '{{eventTitle}} event at {{eventLocation}} on {{eventDate}} - {{brandName}}',
	'{{eventDate}} tarihli {{eventLocation}} {{eventTitle}} etkinliği bileti için ödeme yapın.': 'Make payment for the ticket to the {{eventTitle}} event at {{eventLocation}} on {{eventDate}}.',
	'{{eventDate}} tarihli {{eventLocation}} {{eventTitle}} etkinliği için bilet alın.': 'Buy tickets for the {{eventTitle}} event at {{eventLocation}} on {{eventDate}}.',
	'{{eventDate}} {{eventLocation}} {{eventTitle}} Etkinliği': '{{eventTitle}} Event at {{eventLocation}} on {{eventDate}}',
	'{{eventTitle}} Etkinlikleri.': '{{eventTitle}} Events.',
	'{{eventType}} Hakkında': 'About {{eventType}}',
	'{{optionTitle}} (Seçildi)': '{{optionTitle}} (Selected)',
	'ÖDEME YAP': 'MAKE PAYMENT',
	'Ödeme - {{eventTitle}} / {{eventDate}} {{eventLocation}}': 'Payment - {{eventTitle}} / {{eventDate}} {{eventLocation}}',
	'Ödeme Sistemi': 'Payment System',
	'Ödeme alınamadı. Hata: "{{errorMessage}}"': 'Payment could not be received. Error: "{{errorMessage}}"',
	'QR ile Ödeme Al': 'QR Payment',
	'Ödeme sistemi ile ilgili daha fazla bilgi edinmek için': 'To learn more about the payment system',
	'Ödemenizin tamamı cüzdanınızdan gerçekleştirilecek': 'The full amount of your payment will be charged from your wallet',
	'Öne Çıkan Etkinlik Kuralları': 'Highlighted Event Rules',
	'Önemli Uyarı!': 'Important Warning!',
	'Oluştur': 'Create',
	'Üye Girişi Yap': 'Sign In',
	'Üye bilgileriniz ile ilgili düzenlemeleri sağlayabilirsiniz.': 'You can make changes to your membership information.',
	'Üye girişi yapın.': 'Please sign in.',
	'Üye kayıt işlemi gerçekleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while creating your account, please try again.',
	'Üzgünüz, isteğinizi gerçekleştirirken bir hata ile karşılaştık.': 'Sorry, we encountered an error while processing your request.',
	'Ürün': 'Product',
	'{{count}} Ürün': '{{count}} Products',
	'Şube Raporları': 'Branch Reports',
	'Tüm Şubeler': 'All Branches',
	'Günlük Ciro': 'Daily Revenue',
	'Bir hata oluştu, lütfen daha sonra tekrar deneyin.': 'An error occurred, please try again later.',
	'Bir tutar girmelisiniz.': 'You must enter an amount.',
	'Bir tutar seçmelisiniz.': 'You must select an amount.',
	'Bu kartı kayıtlı kartlarınızdan çıkarmak istediğinizden emin misiniz?': 'Are you sure you want to remove this card from your saved cards?',
	'Bildirimler getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading notifications.',
	'Bilet Seçeneği Seçin': 'Select Ticket Option',
	'Cüzdan bilgileri getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading wallet information, please try again.',
	'İşlemler getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading transactions, please try again.',
	'Siparişiniz oluşturulurken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while creating your order, please try again.',
	'Ödemeniz yapılırken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while processing your payment, please try again.',
	'QR kodu getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading the QR code, please try again.',
	'QR kodu kontrol edilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while checking the QR code, please try again.',
	'İade durumu getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading refund availability, please try again.',
	'İade verisi getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading refund data, please try again.',
	'İadeniz gerçekleşti.': 'Your refund has been processed.',
	'İadeniz gerçekleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while processing your refund, please try again.',
	'Form başarıyla iletildi, teşekkür ederiz.': 'The form was submitted successfully, thank you.',
	'Form getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading the form, please try again.',
	'Form gönderilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while sending the form, please try again.',
	'Fiziksel Kart Eşleştir': 'Pair Physical Card',
	'Giriş işlemi gerçekleştirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while signing in, please try again.',
	'Güncelleme yapılırken bir hata ile karşılaşıldı.': 'An error occurred while updating.',
	'Hesabınıza tanımlı bir satıcı yok. Bunun bir hata olduğunu düşünüyorsanız yönetici ile iletişime geçin.': 'There is no merchant assigned to your account. If you think this is an error, contact the administrator.',
	'Koltuk': 'Seat',
	'Koltuk Ekle': 'Add Seat',
	'Mevcut Bakiyeniz': 'Your Current Balance',
	'Ödeme Adımına Geç': 'Proceed to Payment Step',
	'Ödeme Yapmak İstediğiniz Kartı Seçiniz': 'Select the Card You Want to Pay With',
	'Ödeme yapmak istediğiniz kartı seçmelisiniz.': 'You must select the card you want to pay with.',
	'Ödemeniz başarıyla gerçekleşti.': 'Your payment was completed successfully.',
	'Bahşiş': 'Tip',
	'Yükleme Yap': 'Load Balance',
	'Yüklenecek Bakiye': 'Balance to Be Loaded',
	'Yüklemek İstediğiniz Tutarı Seçiniz': 'Select the Amount You Want to Load',
	'(kayıtlı kartlarım ile öde)': '(pay with my saved cards)',
	'(yeni kart ile öde)': '(pay with a new card)',
	'Çıkış': 'Sign Out',
	'Çıkış yapmak istediğinizden emin misiniz?': 'Are you sure you want to sign out?',
	'Çıkış yapılırken bir hata ile karşılaşıldı.': 'An error occurred while signing out.',
	'1. Atölye': 'Workshop 1',
	'11 Ekim': 'October 11',
	'11 Ekim Cumartesi': 'Saturday, October 11',
	'12 Ekim': 'October 12',
	'12 Ekim Pazar': 'Sunday, October 12',
	'2. Atölye': 'Workshop 2',
	'29 Ekim Çarşamba': 'Wednesday, October 29',
	'3. Atölye': 'Workshop 3',
	'4. Atölye': 'Workshop 4',
	'5. Atölye': 'Workshop 5',
	'6. Atölye': 'Workshop 6',
	'90\'lar Partisi': '90s Party',
	'90\'lar Partisi Etkinlik Programı': '90s Party Event Program',
	'90\'lar Partisi Hakkında': 'About the 90s Party',
	'Aksi bir durum belirtmediğimiz sürece her türlü hava koşulunda gerçekleşecektir.': 'Unless otherwise stated, it will take place in all weather conditions.',
	'Alan Krokisi': 'Venue Map',
	'Ana Sahne': 'Main Stage',
	'Ankara Etkinlikleri ve Ankara Çıkışlı Turlar': 'Ankara Events and Tours Departing from Ankara',
	'Atölye': 'Workshop',
	'BİGE ARAT İLE ÇİÇEK ATÖLYESİ': 'FLOWER WORKSHOP WITH BIGE ARAT',
	'Çocuk': 'Kids',
	'DJ Performans': 'DJ Performance',
	'Festival': 'Festival',
	'Festival Hakkında': 'About the Festival',
	'Bir Hata İle Karşılaşıldı': 'An Error Occurred',
	'Bileklik': 'Wristband',
	'Bliss Out - Artbat @ CerModern': 'Bliss Out - Artbat @ CerModern',
	'Cocktail Fest Ankara': 'Cocktail Fest Ankara',
	'Festival alanına girişler her gün 14:00\'da başlayacaktır.': 'Entrance to the festival area will begin at 14:00 each day.',
	'Festival alanına giriş yapabilmek için kombine veya tek gün bilekliklerinin takılması zorunludur. Bileklikler sadece satın alan kişi tarafından kullanılabilir ve başka kişilere devredilemez. Ayrıca bilekliklerin kaybedilmesi veya çalınması durumunda yenisi çıkarılmaz ve festival alanına tekrar giriş yapılamaz. Katılımcıların alandan çıkması yasaktır. Aynı gün içerisinde alandan çıkılması durumunda tekrar içeri girilebilmesi için yeniden bilet almak zorundadır.': 'To enter the festival area, it is mandatory to wear a combined or single-day wristband. Wristbands may only be used by the purchaser and cannot be transferred to others. In addition, if wristbands are lost or stolen, they will not be replaced and re-entry to the festival area will not be possible. Participants are not allowed to leave the area. If they leave the area on the same day, they must buy a new ticket to re-enter.',
	'Festival sonunda uygulamada bakiye kalması durumunda ne olacak?': 'What happens if there is balance left in the app at the end of the festival?',
	'Festivalin tahsis ettiği bir otopark alanı bulunmamaktadır.': 'There is no parking area allocated by the festival.',
	'Giriş Saati': 'Entry Time',
	'Giriş yapın': 'Sign In',
	'GÜN BOYU!': 'ALL DAY!',
	'Hava Durumu': 'Weather',
	'IF Pay Nasıl Kullanılır?': 'How to Use IF Pay?',
	'Konser': 'Concert',
	'Lineup': 'Lineup',
	'Lineup bilgisi bulunamadı.': 'Lineup information not found.',
	'NFC / Fiziksel Kart Eşleştir': 'Pair NFC / Physical Card',
	'NFC eklendi: {{id}}': 'NFC added: {{id}}',
	'NFC Kart Tanımla': 'Define NFC Card',
	'NFC ile Ödeme Al': 'NFC Payment',
	'Hatalı kart bilgisi.': 'Invalid card information.',
	'Bu sayfaya erişim yetkiniz yok.': 'You do not have permission to access this page.',
	'Eklenen Kartlar:': 'Added Cards:',
	'Kart Bilgisi Hatalı': 'Invalid Card Information',
	'Tekrar Okut': 'Scan Again',
	'Nasıl Bir Etkinlik Arıyorsun?': 'What Kind of Event Are You Looking For?',
	'Konser alanına girişler her gün 17:00\'da başlayacaktır.': 'Entrance to the concert area will begin at 17:00 each day.',
	'Konser alanına giriş yapabilmek için tek gün bilekliklerinin takılması zorunludur. Bileklikler sadece satın alan kişi tarafından kullanılabilir ve başka kişilere devredilemez. Ayrıca bilekliklerin kaybedilmesi veya çalınması durumunda yenisi çıkarılmaz ve konser alanına tekrar giriş yapılamaz. Katılımcıların alandan çıkması yasaktır. Aynı gün içerisinde alandan çıkılması durumunda tekrar içeri girilebilmesi için yeniden bilet almak zorundadır.': 'To enter the concert area, it is mandatory to wear a single-day wristband. Wristbands may only be used by the purchaser and cannot be transferred to others. In addition, if wristbands are lost or stolen, they will not be replaced and re-entry to the concert area will not be possible. Participants are not allowed to leave the area. If they leave the area on the same day, they must buy a new ticket to re-enter.',
	'Konser sonunda uygulamada bakiye kalması durumunda ne olacak?': 'What happens if there is balance left in the app at the end of the concert?',
	'Konserin tahsis ettiği bir otopark alanı bulunmamaktadır.': 'There is no parking area allocated by the concert.',
	'Mabel Matiz Etkinliği Hakkında': 'About the Mabel Matiz Event',
	'Mabel Matiz Etkinliği Line Up': 'Mabel Matiz Event Line Up',
	'Oktoberfest Alan Krokisi': 'Oktoberfest Venue Map',
	'Oktoberfest Alışveriş Sistemi Nasıl Kullanılır?': 'How to Use the Oktoberfest Shopping System?',
	'Oktoberfest Etkinlik Programı': 'Oktoberfest Event Program',
	'Oktoberfest Hakkında & Kurallar': 'About Oktoberfest & Rules',
	'Oktoberfest': 'Oktoberfest',
	'Oktobefest Hakkında & Kurallar': 'About Oktoberfest & Rules',
	'Program': 'Program',
	'Promosyonlar': 'Promotions',
	'REDBULL İLE KENDİ KOKTEYLİNİ YAP!': 'MAKE YOUR OWN COCKTAIL WITH RED BULL!',
	'Parti': 'Party',
	'Pop': 'Pop',
	'Rap': 'Rap',
	'Sayfa Bulunamadı': 'Page Not Found',
	'Stand Up': 'Stand Up',
	'Stand-up': 'Stand-up',
	'Super Müzik Fest Alan Krokisi': 'Super Music Fest Venue Map',
	'Super Müzik Fest Line Up': 'Super Music Fest Line Up',
	'Süper Müzik Fest': 'Super Music Fest',
	'Süper Müzik Fest Hakkında': 'About Super Music Fest',
	'Tiyatro': 'Theatre',
	'THE IRISH EXPERIENCE': 'THE IRISH EXPERIENCE',
	'Telefonunuzun şarjı bittiyse, IF Pay kasa noktalarına gidip QR kart almalısınız. Bu kart sayesinde uygulamayı kullanmaya devam edebilirsiniz, bu nedenle en yakın ödeme noktasına gitmeyi unutmayın. QR kartınızı güvende tutun ve başkalarıyla paylaşmamaya özen gösterin.': 'If your phone battery runs out, you should go to the IF Pay cashier points and get a QR card. Thanks to this card, you can continue using the app, so do not forget to go to the nearest payment point. Keep your QR card safe and be careful not to share it with others.',
	'Timetable': 'Timetable',
	'Tüm Kategoriler': 'All Categories',
	'Tüm Şehirler': 'All Cities',
	'Tur': 'Tour',
	'Uygulama anasayfasının altında bulunan IF Pay butonuna basmanız yeterli olacaktır. Açılan QR kodu sadece 30 saniye geçerlidir. 30 saniye geçtikten sonra "Yenile" butonunu kullanarak QR kodunuzu yenileyebilirsiniz.': 'It is enough to press the IF Pay button located at the bottom of the app home page. The QR code that opens is only valid for 30 seconds. After 30 seconds, you can renew your QR code by using the "Refresh" button.',
	'Uygulamadaki alışveriş sistemi, hesabınıza online kredi kartı ile veya alanda bulunan IF Pay Ödeme noktalarından para yükleyerek çalışır. Yüklediğiniz para, hesabınıza online bakiye olarak aktarılır. Sonrasında istediğiniz ürün veya hizmet için ödeme yapmak için kasa noktalarına gidebilir. Bu noktalarda, uygulamada bulunan size özel ve her alışverişte yenilenen QR kodunu kullanarak alışveriş yapabilirsiniz. QR kodu, ödeme işlemini güvenli ve hızlı bir şekilde tamamlamanızı sağlar. Bu yöntem sayesinde, alışverişlerinizi kolaylıkla gerçekleştirebilir ve uygulamadaki bakiyenizi harcayabilirsiniz.': 'The shopping system in the app works by loading money into your account online with a credit card or from the IF Pay payment points located in the venue. The money you load is transferred to your account as online balance. Afterwards, you can go to the cashier points to pay for any product or service you want. At these points, you can shop by using the QR code in the app that is unique to you and refreshed with every purchase. The QR code allows you to complete the payment process securely and quickly. With this method, you can easily complete your purchases and spend your balance in the app.',
	'WHITE BEACH NASIL YAPILIR?': 'HOW TO MAKE WHITE BEACH?',
	'Workshop': 'Workshop',
	'Workshop\'a Katıl': 'Join Workshop',
	'Workshop katılım limiti dolmuştur.': 'Workshop attendance limit has been reached.',
	'Workshoplar getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading workshops, please try again.',
	'En fazla {{limit}} workshopa katılabilirsiniz.': 'You can attend at most {{limit}} workshops.',
	'Katılımınız başarıyla sağlandı, teşekkür ederiz.': 'Your attendance has been confirmed successfully, thank you.',
	'Katılım güncellenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while updating attendance, please try again.',
	'Katılım güncellendi, teşekkür ederiz.': 'Your attendance has been updated, thank you.',
	'Workshoplar': 'Workshops',
	'Katıl': 'Join',
	'Yönet': 'Manage',
	'Katılımı İptal Et': 'Cancel Attendance',
	'Lineup detayları en kısa zamanda açıklanacaktır.': 'Lineup details will be announced as soon as possible.',
	'Yiyecek İçecek Menüsü': 'Food and Beverage Menu',
	'Üyelik bilgileriniz başarıyla güncellendi.': 'Your membership information was updated successfully.',
	'Üyelik bilgileriniz güncellenirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while updating your membership information, please try again.',
	'İade Edilen Biletler': 'Refunded Tickets',
	'İade Koşulları': 'Refund Conditions',
	'İade edilen': 'refunded',
	'İade İşlemleri': 'Refund Transactions',
	'İade Gerçekleştir': 'Perform Refund',
	'İade Hareketleri': 'Refund Transactions',
	'İade hareketi bulunmuyor.': 'No refund transaction found.',
	'İade işlemini onaylıyor musunuz?': 'Do you confirm the refund process?',
	'Talep ettiğiniz iade tutarı, kredi kartınıza geri yatırılacaktır.': 'The refund amount you requested will be refunded to your credit card.',
	'Cüzdan bakiyeniz minimum iade tutarını ({{total}}) karşılamamaktadır.': 'Your wallet balance does not meet the minimum refund amount ({{total}}).',
	'Sadece online kredi kartı ile yapılan yüklemeler iade alınabilir. Online iade almak için minimum {{total}} online bakiyenizin olması gerekiyor.': 'Only top-ups made with an online credit card can be refunded. To request an online refund, you need a minimum online balance of {{total}}.',
	'Nakit İade': 'Cash Refund',
	'Kart İadesi': 'Card Refund',
	'İşlemde': 'In Progress',
	'Banka Onayı Bekleniyor': 'Waiting for Bank Approval',
	'Tamamlandı': 'Completed',
	'İademin bir kısmını Tip Box\'a aktarmak istiyorum.': 'I want to transfer part of my refund to Tip Box.',
	'Bahşiş tutarınız toplam iade tutarınızdan ({{total}}) fazla olamaz.': 'Your tip amount cannot exceed your total refund amount ({{total}}).',
	'Bir bahşiş tutarı girmelisiniz.': 'You must enter a tip amount.',
	'Bahşiş tutarı': 'Tip amount',
	'İadenizden Tip Box\'a aktarılmasını istediğiniz tutarı girerek devam edin.': 'Enter the amount you want to transfer from your refund to Tip Box and continue.',
	'İletişim / Kişisel Veri İzinleri': 'Communication / Personal Data Permissions',
	'İletişim Formu': 'Contact Form',
	'İsim': 'Name',
	'İşlem Geçmişi': 'Transaction History',
	'İşlem geçmişi getiriliyor...': 'Loading transaction history...',
	'İşlem geçmişiniz getiriliyor...': 'Loading your transaction history...',
	'İşlem geçmişiniz boş.': 'Your transaction history is empty.',
	'İşlem Ücreti': 'Service Fee',
	'Şehir': 'City',
	'Şube': 'Branch',
	'1-Etkinlik sonunda, online yükleme yapanlar cüzdanlarında mobil uygulama üzerinden kredi kartı ile yükledikleri bakiyeden harcamadıkları miktarı otomatik olarak kredi kartlarına iade edilecektir. <br />2-Yükleme noktasından nakit olarak işlem yapanlar için, etkinlik firması tarafından belirtildiği üzere, nakit yüklemelerden kalan bakiyeler iade edilmemektedir. Bu nedenle, yüklediğiniz tutarı harcamanızı öneririz. <br />3-Yükleme noktasından fiziksel kart ile yükleme yapanlar için, etkinlik firmasının belirttiği üzere fiziksel pos ile yapılan yüklemelerden kalan bakiyeler iade edilmemektedir. Bu nedenle, yüklediğiniz tutarı harcamanızı öneririz.': '1-At the end of the event, for users who topped up online, the unspent amount from the balance they loaded via credit card in the mobile app wallet will be automatically refunded to their credit cards. <br />2-For users who made cash transactions at the top-up point, as stated by the event company, the remaining balances from cash top-ups are not refunded. Therefore, we recommend spending the amount you loaded. <br />3-For users who topped up with a physical card at the top-up point, as stated by the event company, the remaining balances from loads made with physical POS are not refunded. Therefore, we recommend spending the amount you loaded.',
	'Ara': 'Search',
	'Arama': 'Search',
	'Bize Ulaşın!': 'Contact Us!',
	'Biletler hakkında tüm soru ve görüşleriniz için': 'For all your questions and feedback about tickets,',
	'Blok {{blockNumber}}, {{rowNumber}}-{{seatNumber}}': 'Block {{blockNumber}}, {{rowNumber}}-{{seatNumber}}',
	'Diğer': 'Other',
	'Dijital dönüşümde taze bir bakış açısı': 'A fresh perspective in digital transformation',
	'Dil Seçimi': 'Language',
	'E-posta': 'Email',
	'Etkinlik Bilgileri ve Kurallar': 'Event Information and Rules',
	'Etkinlik Detayı': 'Event Details',
	'Etkinlik Habercisi ile özel promosyon ve kampanya duyurularını E-posta yoluyla almak istiyorum.': 'I want to receive special promotions and campaign announcements via email from Event Announcer.',
	'Etkinlik Habercisi ile özel promosyon ve kampanya duyurularını SMS yoluyla almak istiyorum.': 'I want to receive special promotions and campaign announcements via SMS from Event Announcer.',
	'Genel Şartlar': 'General Terms',
	'Geçerli bir e-posta adresi girmelisiniz.': 'You must enter a valid email address.',
	'Giriş Yapın': 'Sign In',
	'Hemen Al': 'Buy Now',
	'Hesabınız var mı? Hemen': 'Already have an account? Right away',
	'Hesabınız yok mu? Hemen': 'Do not have an account? Right away',
	'KVKK metnini onaylamalısınız.': 'You must accept the KVKK text.',
	'Kategori': 'Category',
	'Kategoriler': 'Categories',
	'Kayıt Ol': 'Sign Up',
	'Keşfet!': 'Discover!',
	'<0>{{title}}</0> okudum ve içeriğini anladım.': 'I have read and understood <0>{{title}}</0>.',
	'<0>{{title}}</0> içeriğini okudum ve kabul ediyorum.': 'I have read and accept <0>{{title}}</0>.',
	'Güncellenen <0>{{title}}</0> sözleşmesini okudum ve içeriğini anladım.': 'I have read and understood the updated <0>{{title}}</0> agreement.',
	'Kişisel Verilerin Korunması Hakkında Bilgilendirme metnini': 'the Personal Data Protection Information text',
	'Konum': 'Location',
	'Konum Seçimi': 'Location Selection',
	'Lütfen': 'Please',
	'Merhaba': 'Hello',
	'Nerede?': 'Where?',
	'Numarasız': 'Unnumbered',
	'SMS Kodu': 'SMS Code',
	'Sanatçı': 'Artist',
	'Telefon numaranızı adresinizi girmelisiniz.': 'You must enter your phone number and address.',
	'Tüm {{branchTitle}} etkinlikleri.': 'All events in {{branchTitle}}.',
	'Tüm {{eventTitle}} etkinlikleri': 'All {{eventTitle}} events',
	'Yaklaşan': 'Upcoming',
	'Yaklaşan Etkinlikler': 'Upcoming Events',
	'bizi arayabilir veya WhatsApp üzerinden bize yazabilirsiniz!': 'you can call us or message us on WhatsApp!',
	'değiştir': 'change',
	'Değiştir': 'Change',
	'dijital cüzdanınıza bakiye yükleyerek etkinlik alanı içerisinde her türlü içecek ve yiyecek alışverişlerinizi yapabilirsiniz.': 'by loading balance into your digital wallet, you can make all food and beverage purchases within the event area.',
	'etkinliklerin nabzını tut!': 'keep your finger on the pulse of events!',
	'IF Performance harcamalarınız uygulama üzerinden gerçekleşecektir. İçeride nakit veya kredi kartı ödemesi almamaktayız.': 'Your IF Performance spending will be handled through the app. We do not accept cash or credit card payments inside.',
	'IF Performance Mobil Uygulamasını indirmek için': 'To download the IF Performance Mobile App',
	'IF Performance uygulamasını harcamalarınızda kullanabilmek Için öncelikle üye olmalısın. Zaten üye isen giriş yap.': 'To use the IF Performance app for your spending, you must first sign up. If you are already a member, sign in.',
	'Konser alanında içecek ve yiyecek alışverişlerde nakit ve kredi kartı kullanımı mümkün değildir.': 'It is not possible to use cash or credit cards for food and beverage purchases in the concert area.',
	'numaralı telefonuzua gelen SMS kodunu aşağıdaki alana giriniz.': 'Enter the SMS code sent to your phone number below.',
	'SMS kodu gelmedi mi?': 'Didn\'t receive the SMS code?',
	'tekrar gönder': 'resend',
	'tıklayın.': 'click here.',
	'veya': 'or',
	'{{eventType}} sayfasına git': 'Go to the {{eventType}} page',
	'Üye Girişi': 'Member Login',
	'Üye Ol': 'Sign Up',
	'Üye Kaydı Oluştur': 'Create Account',
	'Üyeliğiniz yok ise lütfen aşağıdan üye olunuz.': 'If you do not have an account, please register below.',
	'Üye Ol / Giriş Yap': 'Sign Up / Sign In',
	'Üye Olun': 'Sign Up',
	'Üyelik Sözleşmesi metnini': 'the Membership Agreement text',
	'Üyelik sözleşmesini onaylamalısınız.': 'You must accept the membership agreement.',
	'{{brandName}} şube iletişim bilgileri.': '{{brandName}} branch contact information.',
	'Amacınız': 'Your Goal',
	'Ana hedefleriniz ve amacınız nedir?': 'What are your main goals and purpose?',
	'Bir grup adı girmelisiniz.': 'You must enter a band name.',
	'Bir müzik türü girmelisiniz.': 'You must enter a music genre.',
	'Bir şube seçmelisiniz.': 'You must select a branch.',
	'Daha önce hangi etkinliklerde veya projelerde yer aldığınızı anlatın.': 'Tell us which events or projects you have previously taken part in.',
	'Deneyimleriniz': 'Your Experience',
	'E-Posta Adresi': 'Email Address',
	'Ekip büyüklüğünüzü belirtmelisiniz.': 'You must specify your team size.',
	'Ek Notlar': 'Additional Notes',
	'Grubun ana hedefleri ve amacı nedir?': 'What are the band\'s main goals and purpose?',
	'Grubun sosyal medya hesabını girmelisiniz.': 'You must enter the band\'s social media account.',
	'Grup deneyiminiz ile ilgili bir şeyler yazmalısınız.': 'You must write something about your band experience.',
	'Hangi Şube?': 'Which Branch?',
	'Kayıt aldığınız stüdyonun ismi nedir?': 'What is the name of the studio where you record?',
	'Kayıt stüdyonuzun ismini girmelisiniz.': 'You must enter the name of your recording studio.',
	'Müzik Türü': 'Music Genre',
	'Sahne Senin Başvuru Formu': 'Stage Is Yours Application Form',
	'Sahne İsmi': 'Stage Name',
	'Sahne anlatınızı kısaca yazmalısınız.': 'You must briefly describe your stage story.',
	'Sahne ihtiyacınız var mı? (Backline, enstrüman, mikser vs.)': 'Do you have any stage requirements? (Backline, instrument, mixer, etc.)',
	'Sahneye çıktığınızda ne anlatmak istiyorsunuz?': 'What do you want to express when you take the stage?',
	'Sahnedeki enerjinizi tamamlamalısınız': 'You must describe your stage energy.',
	'Sahnedeki enerjinizi üç kelimeyle tanımlar mısınız?': 'Can you describe your stage energy in three words?',
	'Sizi daha önce nerelerde canlı dinledik? (Varsa link ya da mekan adı)': 'Where have we heard you perform live before? (If available, add a link or venue name)',
	'Sosyal Medya Hesabı': 'Social Media Account',
	'Spotify Linki': 'Spotify Link',
	'Sizin hakkınızda eklemek istediğiniz herhangi bir önemli bilgi veya not.': 'Any important information or note you would like to add about yourself.',
	'Telefon Numarası': 'Phone Number',
	'YouTube Linki': 'YouTube Link',
	'Şube Değiştiriliyor...': 'Branch is being changed...',
	'Kategorileri görmek için "<Link href="placeOrder" className="hyperlink">Sipariş Ver</Link>" butonuna tıklayarak QR kodunu okutunuz.': 'To see the categories, click on the "<Link href="placeOrder" className="hyperlink">Place Order</Link>" button to read the QR code on your table.',
	'Canın ne istiyor?': 'What would you like?',

	// Account / Profile
	'Profil ve Ayarlar': 'Profile & Settings',
	'Profil': 'Profile',
	'Geçmiş Siparişlerim': 'My Past Orders',
	'Çıkış Yap': 'Sign Out',
	'Ödeme Yöntemleri': 'Payment Methods',
	'Ödeme Yöntemi': 'Payment Method',
	'Ödeme Özeti': 'Payment Summary',
	'Ödemeniz bu kart ile yapılacak.': 'Your payment will be made with this card.',
	'Ödeme yapacağınız kartı seçmelisiniz.': 'You must select the card you want to pay with.',
	'Bilgilerimi Güncelle': 'Update My Information',
	'Değişiklikleri Kaydet': 'Save Changes',
	'Güncelle': 'Update',
	'Hesabımı Sil': 'Delete My Account',
	'Hesabınızı Silme': 'Deleting Your Account',
	'Hesabınızı silmek istediğinizde 24 saat içerisinde istediğiniz sonuçlanacak. 6 ay boyunca bilgileriniz sistemimizde saklı kalacaktır.': 'When you request to delete your account, the process will be completed within 24 hours. Your information will remain in our system for 6 months.',
	'Hesap iptali': 'Account Deletion',
	'Hesabınız misafir kullanıcı olarak tanımlı olduğu için bazı bilgileriniz eksik. Uygulamayı kullanmaya başlamak için lütfen aşağıdaki bilgileri doldurun.': 'Your account is registered as a guest user, so some of your information is incomplete. Please fill in the details below to start using the app.',
	'Hesabınıza kayıtlı bir ödeme yöntemi bulunmuyor. Sipariş verirken kartınızı kaydedebilirsiniz.': 'You have no saved payment method on your account. You can save your card while placing an order.',
	'Veri Silme Talebi': 'Data Deletion Request',
	'Veri silme talebinizi aşağıdaki formu doldurarak bize iletebilirsiniz.': 'You can submit your data deletion request by filling out the form below.',
	'Talebimi Gönder': 'Submit My Request',
	'İletişim Tercihleri': 'Communication Preferences',
	'Kampanyalarla ilgili E-Posta almak istiyorum.': 'I want to receive emails about promotions.',
	'Kampanyalarla ilgili SMS almak istiyorum.': 'I want to receive SMS messages about promotions.',
	'* Kampanyalarla ilgili iletişim tercihlerini kapattığında siparişleriniz ve üyelik ayarlarınla ilgili tüm bildirimleri almaya devam edebilirsin.': '* When you turn off campaign-related communication preferences, you will continue to receive all notifications related to your orders and membership settings.',

	// Cards
	'Kart Ekle': 'Add Card',
	'Kart Seç': 'Select Card',
	'Kart Silme': 'Delete Card',
	'Yeni Kart Ekle': 'Add New Card',
	'Yeni Kart Ekleyin': 'Add a New Card',
	'Kaydet ve Kullan': 'Save and Use',
	'Kayıtlı Kartlarınız': 'Your Saved Cards',
	'Kayıtlı Kartınız Bulunmuyor.': 'You Have No Saved Cards.',
	'Kayıtlı Kartlarıma Dön': 'Return to My Saved Cards',
	'Kayıtlı kartlar getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading saved cards.',

	// Table / Order
	'Masa Numarası': 'Table Number',
	'Masa Numaranızı Girin': 'Enter Your Table Number',
	'Masa numaranızı girmelisiniz.': 'You must enter your table number.',
	'Sepet': 'Basket',
	'Sepetiniz getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading your basket.',
	'Sepetinize ürün eklemek için oturduğunuz masanın numarasını girmelisiniz.': 'You must enter your table number to add items to your basket.',
	'Servis Yöntemi': 'Service Method',
	'Servis yöntemi seçmelisiniz.': 'You must select a service method.',
	'Sipariş Numarası:': 'Order Number:',
	'Sipariş Özeti': 'Order Summary',
	'Siparişim': 'My Order',
	'Siparişiniz bulunmuyor.': 'You have no orders.',
	'Siparişler getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar deneyin.': 'An error occurred while loading orders, please try again later.',
	'Sipariş getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading your order.',
	'Sipariş bilgisi getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar deneyin.': 'An error occurred while loading order information, please try again later.',
	'Sipariş Sorgulama': 'Order Lookup',
	'Sipariş oluşturulurken bir hata ile karşılaşıldı.': 'An error occurred while creating your order.',
	'Teslim edildi.': 'Delivered.',
	'Teslimat yöntemi güncellenirken bir hata ile karşılaşıldı.': 'An error occurred while updating the delivery method.',
	'Ürünler Toplamı': 'Products Total',
	'Ürünler getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading products.',
	'Ürün Bulunamadı': 'Product Not Found',
	'Ürün getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading the product, please try again.',

	// Search
	'Arama Geçmişi': 'Search History',
	'Arama geçmişiniz boş, arama kutusuna aramak istediğiniz ürünü yazarak hemen aramaya başlayabilirsiniz.': 'Your search history is empty. You can start searching by typing the product you are looking for in the search box.',
	'Arama sonuçları getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading search results, please try again.',
	'Sonuçlar': 'Results',
	'Önerilen Sonuçlar': 'Suggested Results',

	// Form / User input
	'Adınız': 'Your First Name',
	'Adınız Soyadınız': 'Your Full Name',
	'Soyadınız': 'Your Surname',
	'Telefon Numaranız': 'Your Phone Number',
	'E-Posta Adresiniz': 'Your Email Address',
	'Mesajınız': 'Your Message',
	'Tam adınızı girmelisiniz.': 'You must enter your full name.',
	'Mesafeli satış sözleşmesini kabul etmelisiniz.': 'You must accept the distance sales agreement.',

	// Common UI
	'Onayla': 'Confirm',
	'Hata': 'Error',
	'Başarılı': 'Successful',
	'Uyarı': 'Warning',
	'Hazırlanıyor.': 'Preparing.',
	'Hazır': 'Ready',
	'Hazırlanıyor': 'Preparing',
	'SMS': 'SMS',
	'Sonraki': 'Next',
	'Sonraki Sayfa': 'Next Page',
	'Önceki': 'Previous',
	'Önceki Sayfa': 'Previous Page',
	'Uygulama üzerinden giriş yapmış olduğunuz için': 'Since you signed in through the app',

	// App updates
	'Uygulama için bir güncelleme var.': 'There is an update available for the app.',
	'Site için bir güncelleme var. Lütfen sayfayı yenileyin.': 'There is an update available for the site. Please refresh the page.',

	// Branch / menu errors
	'Menü getirilirken bir hata ile karşılaşıldı, lütfen tekrar deneyin.': 'An error occurred while loading the menu, please try again.',
	'Bannerlar getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading banners.',
	'Şube getirilirken bir hata ile karşılaşıldı.': 'An error occurred while loading the branch.',

	// IF Sokak specific
	'IF Sokak Sitesine Dön': 'Return to IF Sokak Website',
	'IF Sokak uygulamamızı kullanarak şubelerimizde kolayca sipariş verebilirsiniz.': 'You can easily place orders at our branches using the IF Sokak app.',
	'Bilgilendirme: Sipariş verdiğiniz her şube bağımsız olarak hizmet vermektedir. Bu nedenle kart bilgilerinizi her şube için ayrı kaydetmeniz gereklidir.': 'Please note: Each branch you order from operates independently. Therefore, you need to save your card details separately for each branch.',
};

export default en;
